var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_2607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4985 2.63148C23.2225 1.59568 22.4093 0.780037 21.3766 0.503218C19.505 0.000131607 12 0.000131607 12 0.000131607C12 0.000131607 4.495 0.000131607 2.62335 0.503218C1.59076 0.780037 0.777485 1.59568 0.501509 2.63148C0 4.50878 0 8.42566 0 8.42566C0 8.42566 0 12.3425 0.501509 14.22C0.777485 15.2556 1.59076 16.0713 2.62335 16.3482C4.495 16.8512 12 16.8512 12 16.8512C12 16.8512 19.505 16.8512 21.3766 16.3482C22.4093 16.0713 23.2225 15.2556 23.4985 14.22C24 12.3425 24 8.42566 24 8.42566C24 8.42566 24 4.50878 23.4985 2.63148Z",
    fill: "#ED1D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5459 11.9819L15.8186 8.42582L9.5459 4.86943V11.9819Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_2607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16.8511,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.a9dea081d5a762a2c1ba1b163daf9d6b.svg";
export { ForwardRef as ReactComponent };